import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const DeactivateProduct = () => {
  return (
    <>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="subtitle2">
          Vas a desactivar los productos seleccionados de tu inventario.
        </Typography>
        <br />
        <Typography variant="body2">Para reactivarlos, comunícate con tu KAM.</Typography>
      </Box>
    </>
  );
};

export default DeactivateProduct;
